import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchLoginRequest } from '../../../redax/actions/loginActions/loginActions';
import AdminNav from '../../adminTop/AdminNav';
import MypageSideBar from '../../../components/MypageSideBar/MypageSideBar';
import { RootState } from '../../../redax/reducers/rootReducer';
import { fetchRecruiterPlanRequest } from '../../../redax/actions/recruiterPlanActions/recruiterPlanActions';
import { fetchRecruiterPricingRequest } from '../../../redax/actions/recruiterPricingActions/recruiterPricingActions';

var isCheckPlanName = false;
var isHide = false;
const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 2;
const day = 1;
const YYYY = year + '年' + month + '月' + day + '日';
let total = 0;
let nextTotal = 0;
const ChangedPlan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const recruiterPlan = useSelector((state: RootState) => state.recruiterPlan);
  const pricing = useSelector((state: RootState) => state.recruiterPricing);
  // const [plan, setPlan] = useState();
  const [companyId, setCompanyId] = useState();
  const [planName, setPlanName] = useState();
  const [planPrice, setPlanPrice] = useState();
  const [nextContractPlanName, setNextContractPlanName] = useState();
  const [nextContractPlanPrice, setNextContractPlanPrice] = useState();
  const [currenPlanPrice, setcurrenPlanPrice] = useState<any>();
  const [currentPlanId, setCurrentPlanId] = useState();
  const [filteredPrice, setFilteredPrice] = useState();
  const [planList, setPlanList] = useState(Boolean);
  const [optionName1, setOptionName1] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [nextTotalPrice, setNextTotalPrice] = useState(0);
  const [currentDrOption, setCurrentDrOption] = useState(false);
  const [currentWarrantyOption, setCurrentWarrantyOption] = useState(false);
  const [planListsName, setPlanListsName] = useState();
  const [planListsName1, setPlanListsName1] = useState();
  const [planListsPrice, setPlanListsPrice] = useState();
  const [planListsPrice1, setPlanListsPrice1] = useState();
  const [nextPlanListsPrice, setNextPlanListsPrice] = useState();
  const [nextPlanListsPrice1, setNextPlanListsPrice1] = useState();
  const [nextPlanListsName, setNextPlanListsName] = useState();
  const [nextPlanListsName1, setNextPlanListsName1] = useState();
  const [monthDirectScoutLimit, setMonthDirectScoutLimit] = useState();
    
  useEffect(() => {
    if (localStorage.getItem('jobParachannelAuthToken')) {
      // dispatch(fetchLoginRequest('', '',''))
      dispatch(fetchRecruiterPlanRequest());
      dispatch(fetchRecruiterPricingRequest());
    } else (
        navigate('/recruiter/login/')
    )
  }, [dispatch]);
    
  useEffect(() => {
    total = 0;
    nextTotal = 0;
    if(recruiterPlan !== undefined && recruiterPlan.pending && pricing.pending){
      setCompanyId(recruiterPlan.recruiterPlan.company_id);
      var currentName = recruiterPlan.recruiterPlan.current_plan_name;
      if(currentName == "無料" || currentName == "無料プラン") {
        isCheckPlanName = true;
        isHide = false;
      } else {
        isCheckPlanName = false;
        isHide = true;
      }
      const currentPlanId = recruiterPlan.recruiterPlan.current_plan_id;
      setCurrentDrOption(recruiterPlan.recruiterPlan.current_dr_option);
      setCurrentWarrantyOption(recruiterPlan.recruiterPlan.current_warranty_option);
      const currentPlan = recruiterPlan.recruiterPlan.plan_lists.find((plan:any) => plan.id === currentPlanId);
      const nextContractPlan = recruiterPlan.recruiterPlan.next_contract;
      const nextContractPlanId = pricing.recruiterPricing.plan_lists.find((plan:any) => plan.id === recruiterPlan.recruiterPlan.next_contract.plan_id);
      const optionName = pricing.recruiterPricing.plan_lists.find((plan:any) => plan.id === currentPlanId);
      const planList = pricing.recruiterPricing.plan_lists; 
      if(nextContractPlanId && nextContractPlanId.option.length > 0){
        setNextPlanListsName(nextContractPlanId.option[0].option_name);
        setNextPlanListsName1(nextContractPlanId.option[1].option_name);
        setNextPlanListsPrice(nextContractPlanId.option[0].price);
        setNextPlanListsPrice1(nextContractPlanId.option[1].price);
      };           
      if(optionName && optionName.option.length > 0){        
        setPlanListsPrice(optionName.option[0].price);
        setPlanListsPrice1(optionName.option[1].price);
        setMonthDirectScoutLimit(optionName.option[1].month_direct_scout_limit);
        let a = optionName.option[0].option_name;
        let b = optionName.option[1].option_name;
        setPlanListsName(a);
        setPlanListsName1(b);
      }
      if(recruiterPlan.recruiterPlan.current_dr_option && recruiterPlan.recruiterPlan.current_warranty_option ){
        setTotalPrice(optionName.option[0].price + optionName.option[1].price)
      } else if(recruiterPlan.recruiterPlan.current_dr_option && !recruiterPlan.recruiterPlan.current_warranty_option){
        setTotalPrice(optionName.option[0].price)
      } else if (!recruiterPlan.recruiterPlan.current_dr_option && recruiterPlan.recruiterPlan.current_warranty_option) {
        setTotalPrice(optionName.option[1].price)
      } else {
        setTotalPrice(0);
      }
      
      if (currentPlan && currentPlan.length > 0) {
        setPlanName(currentPlan.name);
        setPlanPrice(currentPlan.price);
      } else {
          // Handle the case where the current plan is not found
      }

      if (nextContractPlan && nextContractPlan.length > 0) {
        nextTotal = 0;
        setNextContractPlanName(recruiterPlan.recruiterPlan.next_contract.plan_name);          
        setNextContractPlanPrice(recruiterPlan.recruiterPlan.next_contract.plan_price);
        for(let j = 0; j < planList.length; j++) {
          if(planList[j].id == recruiterPlan.recruiterPlan.next_contract.plan_id){
            if(recruiterPlan.recruiterPlan.next_contract.dr_option == true) {
              setNextTotalPrice(nextTotal += planList[j].option[0].price);
            }
            if(recruiterPlan.recruiterPlan.next_contract.warranty_option == true) {      
              setNextTotalPrice(nextTotal += planList[j].option[1].price);
            }
          }
        }
      }
      setcurrenPlanPrice(recruiterPlan.recruiterPlan.current_plan_price);
      setCurrentPlanId (recruiterPlan.recruiterPlan.current_plan_id);
      // Find the plan object whose id matches the current_plan_id
      const filteredPlan = recruiterPlan.recruiterPlan.plan_lists.find((plan:any) => plan.id === 1);
      // Retrieve the price from the filtered plan
      setFilteredPrice( filteredPlan ? filteredPlan.price : null );
      if(filteredPlan == undefined){
        setPlanList(false);
      } else {
        setPlanList(true);
      }
      if (optionName && optionName.length > 0) {
        setTotalPrice(optionName.option[0].price + optionName.option[1].price);
      } else {
        // Handle the case where the current plan is not found
      }
    }
  }, [recruiterPlan]);

  function logout() {
    if (localStorage.entryFlag) {
      localStorage.removeItem("entryFlag");
    }
    if (localStorage.jobParachannelAuthToken) {
      localStorage.removeItem("jobParachannelAuthToken");
      navigate("/");
      window.location.reload();
    }
  }
  
  return (
    <main id='company'>
        <section className='sectionScouts' style={{width:"100%"}}>
          <div style={{display:"flex", justifyContent:"space-between", width:"100%"}}>
            <ul className="bread_crumb">
              <li>
                <a href="/">トップ</a>
              </li>
              <li>
                <a href="/recruiter/">企業様マイページ</a>
              </li>
              <li>
                <a href="#">プラン管理</a>
              </li>
            </ul>
            <div className="ttl_box">
              <ul>
                <li>
                  <a href="#" onClick={logout}>
                    <img src="/assets/img/company/icon02.svg" alt="" />
                    ログアウト
                  </a>
                </li>
              </ul>
            </div>
          </div>
            <h2 className='adminH2' style={{margin:"0", color:"#00a0e9", marginTop:"30%"}}>プランの変更が完了しました</h2>
            <br />
            <br /><br /><br />
            <button className='scoutsBtn' onClick={()=>window.location.href = ('/recruiter/plan')} style={{marginRight:"10px"}}>プランを確定</button>
      </section>
    </main>
  )
}

export default ChangedPlan
